if (!window.addToCartListenerAdded) {
  window.addToCartListenerAdded = true;

  document.body.addEventListener('click', (event) => {
    const addBtn = event.target.closest('.add-to-cart-button');
    if (!addBtn || addBtn.classList.contains('gift-card-button')) return;
    if (addBtn) {
      event.preventDefault();

      const cardWrapper = addBtn.closest('.card-product');
      if (cardWrapper) {
        cardWrapper.style.overflow = 'visible';
      }

      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: addBtn.dataset.variantId, quantity: 1 }),
      })
        .then((response) => {
          if (!response.ok) throw new Error('Errore aggiunta al carrello');
          return response.json();
        })
        .then((data) => {
          const popup = document.getElementById('popup-notification');
          const message = document.getElementById('popup-message');
          const closeBtn = document.getElementById('popup-close');
          const counterSpan = document.getElementById('popup-counter');
          window.dataLayer = window.dataLayer || [];
          const cartData = window.GTMData.value;
          const productName = data.product_title;
          const price = data.price / 100;
          const quantity = data.quantity || 1;
          const currency = data.currency || 'EUR';
          const maxPrice = data.original_price / 100 || price;
          const finalPrice = price;
          const discount = Math.max(0, maxPrice - finalPrice);
          const item = {
            item_id: data.sku,
            item_name: productName,
            item_brand: data.vendor || '',
            price: price,
            quantity: quantity,
            discount: discount,
          };

          const addToCartEvent = {
            event: 'add_to_cart',
            ecommerce: {
              currency: currency,
              value: cartData,
              items: [item],
            },
          };
          window.dataLayer.push({ ecommerce: null });
          window.dataLayer.push(addToCartEvent);
          console.log('add_to_cart event pushed to dataLayer:', addToCartEvent);

          message.textContent = `${data.title}`;

          popup.classList.remove('hidden');

          let secondsRemaining = 4;
          counterSpan.textContent = secondsRemaining;

          const countdownInterval = setInterval(() => {
            secondsRemaining--;
            if (secondsRemaining <= 0) {
              clearInterval(countdownInterval);
            } else {
              counterSpan.textContent = secondsRemaining;
            }
          }, 1000);

          const timeoutId = setTimeout(() => {
            clearInterval(countdownInterval);
            popup.classList.add('hidden');
          }, secondsRemaining * 1000);

          closeBtn.onclick = () => {
            clearInterval(countdownInterval);
            clearTimeout(timeoutId);
            popup.classList.add('hidden');
          };

          return fetch('/cart.js').then((res) => res.json());
        })
        .then((cart) => {
          const cartCountBubbleContainer =
            document.querySelector('.cart-count-bubble');
          const cartCountBubble = document.querySelector(
            "#cart-icon-bubble .cart-count-bubble span[aria-hidden='true']"
          );
          const visuallyHidden = document.querySelector(
            '#cart-icon-bubble .cart-count-bubble .visually-hidden'
          );
          const cartDrawer = document.getElementById('CartDrawerContainer');
          const cartDrawerEmptyContainer = document.querySelector(
            '.drawer__inner-empty'
          );
          const cartDrawerButton = document.getElementById(
            'CartDrawer-Form-Cta'
          );
          if (cartCountBubble && visuallyHidden && cartCountBubbleContainer) {
            cartCountBubbleContainer.style.display =
              cart.item_count > 0 ? 'flex' : 'none';
            cartCountBubble.textContent = cart.item_count;
            visuallyHidden.textContent = `${cart.item_count} ${
              window.mainCartItemsLabel || 'articoli'
            }`;
          }

          if (cartDrawer && cartDrawerEmptyContainer && cartDrawerButton) {
            cartDrawer.classList.remove('is-empty');
            cartDrawerEmptyContainer.style.display = 'none';
            cartDrawerButton.removeAttribute('disabled');
          }

          const drawerHeading = document.querySelector('.cart-drawer__heading');
          if (drawerHeading) {
            const singleText = drawerHeading.dataset.i18nSingle;
            const multipleText = drawerHeading.dataset.i18nMultiple;

            const text =
              cart.item_count === 1
                ? singleText.replace('{{ count }}', cart.item_count)
                : multipleText.replace('{{ count }}', cart.item_count);

            drawerHeading.textContent = text;
          }
          if (
            typeof publish !== 'undefined' &&
            typeof PUB_SUB_EVENTS !== 'undefined'
          ) {
            publish(PUB_SUB_EVENTS.cartUpdate, {
              source: 'pr-card-product',
              cartData: cart,
            });
          }
        })
        .catch((err) => alert(err.message));

      return;
    }
  });
}

document.addEventListener('DOMContentLoaded', () => {
  const cards = document.querySelectorAll('.card-product');
  const vendors = document.querySelectorAll('.card-product-vendor');

  cards.forEach((card) => {
    const img = card.querySelector('.card-product-img');
    const titleLink = card.querySelector('.card-product-title a');

    const toggleActive = () => {
      cards.forEach((c) => c !== card && c.classList.remove('active'));
      card.classList.add('active');
    };

    const handleClick = (event) => {
      event.preventDefault();
      toggleActive();
      window.location.href = titleLink.href;
    };

    if (img) {
      img.addEventListener('click', handleClick);
    }
    if (titleLink) {
      titleLink.addEventListener('click', handleClick);
    }
  });

  vendors.forEach((vendor) => {
    vendor.addEventListener('click', (event) => {
      event.preventDefault();

      vendors.forEach((v) => v.classList.remove('active'));

      vendor.classList.add('active');

      const link = vendor.querySelector('a');
      if (link) {
        window.location.href = link.href;
      }
    });
  });

  const addToCartButtons = document.querySelectorAll('.add-to-cart-button');

  addToCartButtons.forEach((button) => {
    button.addEventListener('focus', () => {
      document.querySelectorAll('.card-product').forEach((card) => {
        card.classList.remove('active-add-to-cart');
      });
      const card = button.closest('.card-product');
      if (card) {
        card.classList.add('active-add-to-cart');
      }
    });

    button.addEventListener('blur', () => {
      const card = button.closest('.card-product');
      if (card) {
        card.classList.remove('active-add-to-cart');
      }
    });
  });
});
